import styled from 'styled-components'

import { WorkspaceLogo } from '@sketch/components'
import { ReactComponent as ArchiveBoxSvg } from '@sketch/icons/archive-box-16'
import { ReactComponent as TrashSvg } from '@sketch/icons/trash-empty-prism-16'

import { TILE_MEDIA_SIZE } from './constants'

/** Glyph shown in the icon tile of an archived-folder preview. */
export const ArchiveIcon = styled(ArchiveBoxSvg)`
  width: 36px;
  height: 36px;
`

/** Glyph shown in the icon tile of a trashed / permanently-deleted preview. */
export const TrashIcon = styled(TrashSvg)`
  width: 36px;
  height: 36px;
`

/**
 * Workspace logo sized to fill a preview tile. `WorkspaceLogo` only goes up to
 * 88px, so we pass that for its letter sizing and stretch the box to the tile
 * size (matching how the list-item `SubjectWorkspaceLogo` overrides it).
 */
export const WorkspaceTile = styled(WorkspaceLogo)`
  width: ${TILE_MEDIA_SIZE};
  height: ${TILE_MEDIA_SIZE};
  border-radius: 12px;
  margin-bottom: 8px;

  &::after {
    border-radius: 12px;
  }
`
